import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Input,
    Label,
    Row,
    Table,
} from "reactstrap";
import swal from "sweetalert";
import { ButtonStyles } from "../../constants/ButtonStyles";
import { getLoadingSheet } from "../../util/APIUtils";
import { LoadingOverlay } from "../../util/Helpers";

const today = () => new Date().toISOString().substring(0, 10);

const LoadingSheet = () => {
    const [block, setBlock] = useState(false);
    const [loadingSheet, setLoadingSheet] = useState([]);
    const [dateFilter, setDateFilter] = useState({
        startDate: today(),
        endDate: today(),
    });

    useEffect(() => {
        loadLoadingSheet();
    }, []);

    const loadLoadingSheet = () => {
        if (!dateFilter.startDate || !dateFilter.endDate) {
            swal({ text: "Please select both start and end dates" });
            return;
        }

        if (dateFilter.startDate > dateFilter.endDate) {
            swal({ text: "Start date cannot be after end date" });
            return;
        }

        setBlock(true);
        getLoadingSheet(dateFilter)
            .then((response) => {
                setLoadingSheet(Array.isArray(response) ? response : []);
                setBlock(false);
            })
            .catch((error) => {
                setBlock(false);
                swal({ text: "Unable to load loading sheet: " + error.message });
            });
    };

    const handleDateChange = ({ target: { name, value } }) => {
        setDateFilter((previousState) => ({
            ...previousState,
            [name]: value,
        }));
    };

    const clearDates = () => {
        const currentDate = today();
        setDateFilter({ startDate: currentDate, endDate: currentDate });
        setLoadingSheet([]);
    };

    return (
        <div className="animated fadeIn">
            {block && <LoadingOverlay />}
            <Card
                style={{
                    borderRadius: "15px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                    border: "none",
                    overflow: "hidden",
                }}
            >
                <CardHeader
                    style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        padding: "20px 25px",
                        borderBottom: "none",
                    }}
                >
                    <i className="fa fa-truck" style={{ fontSize: "24px", color: "#fff", marginRight: "12px" }} />
                    <strong style={{ fontSize: "1.2rem", color: "#fff" }}>Loading Sheet</strong>
                </CardHeader>
                <CardBody style={{ padding: "25px" }}>
                    <Row className="mb-3" style={{ alignItems: "end" }}>
                        <Col sm="3">
                            <Label for="startDate">Start Date</Label>
                            <Input
                                bsSize="sm"
                                type="date"
                                name="startDate"
                                id="startDate"
                                value={dateFilter.startDate}
                                onChange={handleDateChange}
                            />
                        </Col>
                        <Col sm="3">
                            <Label for="endDate">End Date</Label>
                            <Input
                                bsSize="sm"
                                type="date"
                                name="endDate"
                                id="endDate"
                                value={dateFilter.endDate}
                                onChange={handleDateChange}
                            />
                        </Col>
                        <Col sm="4">
                            <Button style={{ ...ButtonStyles.primarySm, marginRight: "10px" }} onClick={loadLoadingSheet}>
                                <i className="fa fa-search" style={{ marginRight: "5px" }} />
                                Search
                            </Button>
                            <Button style={ButtonStyles.secondarySm} onClick={clearDates}>
                                <i className="fa fa-times" style={{ marginRight: "5px" }} />
                                Clear
                            </Button>
                        </Col>
                    </Row>

                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Product name</th>
                                <th>Unit</th>
                                <th className="text-right">MRP</th>
                                <th className="text-right">Total Units Sold</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingSheet.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center">No loading sheet data found</td>
                                </tr>
                            ) : (
                                loadingSheet.map((item, index) => (
                                    <tr key={`${item.id}`}>
                                        <td>{item.id}</td>
                                        <td>{item.productDescription}</td>
                                        <td>{item.unit}</td>
                                        <td className="text-right">{Number(item.mrp).toFixed(2)}</td>
                                        <td className="text-right">{item.totalBaseUnitsSold}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </div>
    );
};

export default LoadingSheet;


// WEBPACK FOOTER //
// ./src/components/CustomComponents/LoadingSheet.js